module.exports = __webpack_public_path__ + "static/media/jpsk.9472430c.png";